module.exports = __webpack_public_path__ + "static/media/whatsapp_16px.3b6c10db.svg";